<template>
	<div style="height: 100%;">
		<!-- 流程详情 -->
		<div class="condition">
			<div class="item"><span>流程名称：</span>{{processDetail.flowchart.Name}}</div>
			<div class="item"><span>创建时间：</span>{{processDetail.flowchart.Time}}</div>
			<div class="item"><span>类型：</span>{{processDetail.flowchart.FlowchartType==1?'采伐证审批':processDetail.flowchart.FlowchartType==2?'用火审批':'事件处理'}}</div>
			<div class="item" v-if="processDetail.flowchart.FlowchartType==3"><span>事件类型：</span>{{processDetail.flowchart.EventType==1?'巡护上报':processDetail.flowchart.EventType==2?'群众上报': processDetail.flowchart.EventType==2? '内部上报' : '统一上报'}}</div>
			<div class="item" v-if="processDetail.flowchart.FlowchartType==3"><span>区域：</span>{{processDetail.flowchart.AreaName}}</div>
			<div class="item"><span>状态：</span>{{processDetail.flowchart.State==1?'启用':'关闭'}}</div>
		</div>
		<div class="processContent">
			<el-scrollbar style="height: 90%" ref="scrollbar">
				<div class="design-engine" v-if="processDetail">
					<div class="dingflow-design">
						<div class="ie-polyfill-container">
							<!-- 采伐证审批详情 -->
							<div class="box-scale" id="box-scale" v-show="processDetail.flowchart.FlowchartType==1">
								<div class="node-wrap" v-for="(item, index) in processDetail.flowchartNode">
									<div class="node-wrap-box node_sid-startevent start-node">
										<div>
											<div class="arrows">
												<div class="title" :class="'node-type-' + item.nodeType">
													<span class="edit-title">{{ item.nodeName }}</span>
												</div>
											</div>
											<div class="content">
												<div class="text" v-if="item.nodeType!=2">{{ item.departmentName+'：' + item.userName }}</div>
												<div class="text" v-else>用户提交</div>
											</div>
										</div>
									</div>
									<div class="add-node-btn-box">
										<div class="add-node-btn">
										</div>
									</div>
								</div>
								<div class="end-node">
									<div class="end-node-circle"></div>
									<div class="end-node-text">流程结束</div>
								</div>
							</div>
							<!-- 事件处理详情 -->
							<div class="box-scale" id="box-scale" v-show="processDetail.flowchart.FlowchartType==3">
								<div class="node-wrap" v-for="(item, index) in processDetail.flowchartNode">
									<div class="node-wrap-box node_sid-startevent start-node">
										<div>
											<div class="arrows">
												<div class="title" :class="'node-type-' + item.nodeType">
													<span class="edit-title">{{ item.nodeTypeName }}</span>
												</div>
											</div>
											<div class="content">
												<div>
													<div class="text">{{item.nodeName}}</div>
													<div class="text margin-top-sm">处理人：{{ item.userName }}</div>
												</div>
											</div>
										</div>
									</div>
									<div class="add-node-btn-box">
										<div class="add-node-btn">
										</div>
									</div>
								</div>
								<div class="end-node">
									<div class="end-node-circle"></div>
									<div class="end-node-text">流程结束</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					暂无数据
				</div>
			</el-scrollbar>
		</div>
	</div>
</template>

<script>
import {GetDetails} from '@/api/Flowchart'
export default {
	name: 'Dialog',
	props: {
	},
	data() {
		return {
			processDetail:{
				flowchart:{
					Name:'',
					Time:'',
					FlowchartType:1,
					State:1
				},
				flowchartNode:[]
			}
		};
	},
	methods: {
		handleClose(){
			this.$emit('close-dialog', false);
		},
		handleConfirm() {
			this.$emit('dialog-fell-confirm', false);
		},
		getProcessDetail(id){
			if(id){
				GetDetails(parseInt(id)).then(res=>{
					if(res.data.state==1){
						this.processDetail = res.data.data
					}
				})
			}else{
				this.processDetail = {}
			}	
		}
	}
};
</script>

<style lang="less" scoped>
.condition {
	margin-top: 10px;
	display: flex;
	flex-wrap: wrap;
	.item {
		// flex: 1;
		width: 25%;
		display: flex;
		align-items: center;
		padding: 0 10px;
		white-space: nowrap; 
		overflow: hidden;
		text-overflow: ellipsis;
		margin-bottom: 20px;
		span {
			width: 100px;
			text-align: right;
		}
	}
}
.processContent {
	height: 100%;
	margin-top: 30px;
	.design-engine {
		position: relative;
		height: 100%;
		.dingflow-design {
			width: 100%;
			// background-color: #f5f5f7;
			overflow: auto;
			height: 100%;
			position: relative;
			bottom: 0;
			left: 0;
			right: 0;
			top: 0;
			/deep/ .ant-popover-arrow {
				display: none !important;
			}
			.ie-polyfill-container {
				display: -ms-grid;
				-ms-grid-columns: min-content;
				.box-scale {
					transform: scale(1);
					display: inline-block;
					position: relative;
					width: 100%;
					// padding: 54.5px 0;
					-webkit-box-align: start;
					-ms-flex-align: start;
					align-items: flex-start;
					-webkit-box-pack: center;
					-ms-flex-pack: center;
					justify-content: center;
					-ms-flex-wrap: wrap;
					flex-wrap: wrap;
					min-width: -webkit-min-content;
					min-width: -moz-min-content;
					min-width: min-content;
					// background-color: #f5f5f7;
					-webkit-transform-origin: 0 0 0;
					transform-origin: 50% 0px 0px;
					overflow: scroll;
					height: 730px;
					.node-wrap {
						display: inline-flex;
						flex-direction: column;
						-webkit-box-pack: start;
						-ms-flex-pack: start;
						justify-content: flex-start;
						-webkit-box-align: center;
						-ms-flex-align: center;
						align-items: center;
						-ms-flex-wrap: wrap;
						flex-wrap: wrap;
						-webkit-box-flex: 1;
						-ms-flex-positive: 1;
						width: 100%;
						// padding: 0 50px;
						position: relative;
						.node-wrap-box {
							display: -webkit-inline-box;
							display: -ms-inline-flexbox;
							display: inline-flex;
							-webkit-box-orient: vertical;
							-webkit-box-direction: normal;
							-ms-flex-direction: column;
							flex-direction: column;
							position: relative;
							// width: 220px;
							min-height: 72px;
							-ms-flex-negative: 0;
							flex-shrink: 0;
							background: #ffffff;
							border-radius: 4px;
							// cursor: pointer;
							.close {
								display: none;
								position: absolute;
								right: 10px;
								top: 50%;
								transform: translateY(-50%);
								width: 20px;
								height: 20px;
								font-size: 14px;
								color: #fff;
								border-radius: 50%;
								text-align: center;
								line-height: 20px;
							}
							&:hover {
								.close {
									display: block;
								}
								// &::after {
								//   border: 1px solid #3296fa;
								//   box-shadow: 0 0 6px 0 rgba(50, 150, 250, 0.3);
								// }
							}
							&::after {
								pointer-events: none;
								content: '';
								position: absolute;
								top: 0;
								bottom: 0;
								left: 0;
								right: 0;
								z-index: 2;
								border-radius: 4px;
								border: 1px solid transparent;
								transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
								box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
							}
							//审批
							.node-type-1 {
								background: rgb(87, 106, 149);
							}
							.node-type-2 {
								background: rgb(255, 148, 62);
							}
							.node-type-3 {
								background: rgb(255, 170, 255);
							}
							.node-type-4 {
								background: rgb(50, 150, 250);
							}
							.title {
								position: relative;
								display: flex;
								align-items: center;
								padding-left: 16px;
								padding-right: 30px;
								width: 100%;
								height: 24px;
								line-height: 24px;
								font-size: 12px;
								color: #ffffff;
								text-align: left;
								border-radius: 4px 4px 0px 0px;
								box-sizing: border-box;
								.edit-title {
									line-height: 15px;
									overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
									border-bottom: dashed 1px transparent;
									&::before {
										content: '';
										position: absolute;
										top: 0;
										left: 0;
										bottom: 0;
										right: 40px;
									}
								}
							}
							.content {
								position: relative;
								font-size: 14px;
								padding: 16px;
								padding-right: 30px;
								.text {
									display: block;
									white-space: nowrap;
								}
							}
						}
						.add-node-btn-box {
							width: 240px;
							display: -webkit-inline-box;
							display: -ms-inline-flexbox;
							display: inline-flex;
							-ms-flex-negative: 0;
							flex-shrink: 0;
							-webkit-box-flex: 1;
							-ms-flex-positive: 1;
							position: relative;
							&::before {
								content: '';
								position: absolute;
								top: 0;
								left: 0;
								right: 0;
								bottom: 0;
								z-index: 0;
								margin: auto;
								width: 2px;
								height: 100%;
								background-color: #cacaca;
							}
							.add-node-btn {
								user-select: none;
								width: 240px;
								padding: 20px 0px 32px;
								display: flex;
								-webkit-box-pack: center;
								justify-content: center;
								flex-shrink: 0;
								-webkit-box-flex: 1;
								flex-grow: 1;
								.btn {
									position: relative;
									cursor: pointer;
									color: #fff;
									font-size: 16px;
									&:hover {
										transform: scale(1.3);
										box-shadow: 0 13px 27px 0 rgba(0, 0, 0, 0.1);
									}
									.iconfont {
										color: #fff;
										font-size: 16px;
									}
								}
							}
						}
					}

					.end-node {
						border-radius: 50%;
						font-size: 14px;
						color: rgba(25, 31, 37, 0.4);
						// text-align: left;
						width: 100px;
						position: relative;
						top: 10px;
						left: 50%;
						transform: translateX(-50%);
						.end-node-circle {
							width: 10px;
							height: 10px;
							margin: auto;
							border-radius: 50%;
							background: #dbdcdc;
						}
						.end-node-text {
							margin-top: 5px;
							text-align: center;
						}
					}
				}
			}
		}
	}
}
</style>
<style lang="less" scoped>
/deep/ .el-dialog__headerbtn .el-dialog__close {
	color:#fff!important;
}
</style>
